<form [formGroup]="ContentOptionQuestion">
    <fieldset class="col-12">
        <legend>
            <span>Registro</span>
        </legend>
        <div class="card">
            <div class="card-body">
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label>Descripción</label>
                        <input type="text" class="form-control" formControlName="opt_vc_description">
                    </div>
                </div>
                <div class="form-row">
                    
                    <div class="form-group col-md-6">
                        <label>¿Es Correcta?</label>
                        <select class="form-control" formControlName="opt_bt_correct">
                            <option value="">Seleccionar</option>
                            <option value="1">Correcto</option>
                            <option value="0">Incorrecto</option>
                        </select>
                
                    </div>
                    <div class="form-group col-md-3">
                        <label>&nbsp;</label>
                        <button class="btn btn-badminton btn-block" (click)="cancel()">Cancelar</button>
                    </div>
                    <div class="form-group col-md-3">
                        <label>&nbsp;</label>
                        <button class="btn btn-badminton btn-block" (click)="save()">Guardar</button>
                    </div>
                </div>

               <hr>

                <div class="row">
                    <div class="col-12">
                        <table mat-table [dataSource]="dataSource" matSort class="col-12">
                            <ng-container matColumnDef="opt_vc_description">
                                <th style="width: 70%;" mat-header-cell mat-sort-header *matHeaderCellDef>
                                    Descripción</th>
                                <td mat-cell *matCellDef="let element"> {{element.opt_vc_description}} </td>
                            </ng-container>
        
                            <ng-container matColumnDef="opt_vc_correct">
                                <th style="width: 15%;" mat-header-cell mat-sort-header *matHeaderCellDef>
                                    Correcto</th>
                                <td mat-cell *matCellDef="let element"> {{element.opt_vc_correct}} </td>
                            </ng-container>

                            <ng-container matColumnDef="opcion">
                                <th style="width: 15%;" mat-header-cell *matHeaderCellDef> Opciones</th>
                                <td mat-cell *matCellDef="let element">
                                    <a (click)="delete(element)" class="pr-2"><i class="fa fa-remove"></i> Eliminar</a>
                                </td>
                            </ng-container>
        
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>

    </fieldset>
   
</form>

 